class LayerHelper {
  constructor(layers, selectedLayerId, collapsedLayerId) {
    this._layers = layers;
    this._selectedLayerId = selectedLayerId;
    this._collapsedLayerId = collapsedLayerId;
  }

  layers() {
    return this._layers;
  }

  selectedLayerId() {
    return this._selectedLayerId;
  }

  collapsedLayerId() {
    return this._collapsedLayerId;
  }

  indexOfSelectedLayer() {
    const indexOfSelectedLayer = this.layers().findIndex(
      (l) => l.id() === this.selectedLayerId(),
    );
    return indexOfSelectedLayer;
  }

  activeLayers() {
    const activeLayers = this.layers().slice(
      0,
      this.indexOfSelectedLayer() + 1,
    );
    return activeLayers;
  }

  collapsedLayers() {
    if (!this.collapsedLayerId()) {
      return [];
    }
    let collapsedLayerFound = false;
    const results = this.activeLayers().filter((l) => {
      const include = !collapsedLayerFound;
      collapsedLayerFound =
        collapsedLayerFound || l.id() === this.collapsedLayerId();
      return include;
    });
    if (!collapsedLayerFound) {
      return results.slice(0, results.length - 1);
    }
    return results;
  }

  inactiveLayers() {
    const inactiveLayers = this.layers().slice(this.indexOfSelectedLayer() + 1);
    return inactiveLayers;
  }

  enabledLayers() {
    const enabledLayers = this.activeLayers().filter((l) => l.enabled());
    return enabledLayers;
  }

  relevantLayers(layer) {
    const index = this.layers().findIndex((l) => l.id() === layer.id());
    const relevantLayers = this.layers()
      .slice(0, index)
      .filter((l) => l.enabled());
    return relevantLayers;
  }
}

export default LayerHelper;
